import api from './api';

/**
 * Chiamate della fatturazione.
 *
 * Le regole stanno nel backend e nel database: qui non si duplicano
 * controlli, si presentano i messaggi che arrivano.
 */
export const fatturazioneAPI = {
    // --- soggetti
    soggettoDaPaziente: (pazienteId) =>
        api.post(`/fatturazione/soggetti/da-paziente/${pazienteId}`),
    cercaSoggetti: (q) => api.get('/fatturazione/soggetti', { params: { q } }),

    // --- prestazioni pronte da fatturare
    daFatturare: (pazienteId) => api.get(`/fatturazione/da-fatturare/${pazienteId}`),

    // --- documenti
    elenco: (params) => api.get('/fatturazione', { params }),
    /* params.paziente_id: dal contesto di un paziente il server serve solo
       un documento suo. La pagina Fatturazione lo chiama senza. */
    dettaglio: (id, params) => api.get(`/fatturazione/${id}`, { params }),
    creaBozza: (dati) => api.post('/fatturazione', dati),
    aggiungiRiga: (id, riga) => api.post(`/fatturazione/${id}/righe`, riga),
    eliminaRiga: (id, rigaId) => api.delete(`/fatturazione/${id}/righe/${rigaId}`),
    impostaBollo: (id, escluso) => api.patch(`/fatturazione/${id}/bollo`, { escluso }),
    /* Sconto sul totale: il server lo ripartisce sulle basi imponibili
       aliquota per aliquota, cosi' l'IVA resta coerente con la base. */
    impostaSconto: (id, sconto) => api.patch(`/fatturazione/${id}/sconto`, { sconto }),
    // Quantita' e sconto di una riga in bozza, senza cancellarla e rifarla
    modificaRiga: (id, rigaId, dati) =>
        api.patch(`/fatturazione/${id}/righe/${rigaId}`, dati),
    emetti: (id, dati = {}) => api.post(`/fatturazione/${id}/emetti`, dati),
    annulla: (id, motivo) => api.post(`/fatturazione/${id}/annulla`, { motivo }),
    incassa: (id, dati) => api.post(`/fatturazione/${id}/incassi`, dati),
    spettanze: (params) => api.get('/fatturazione/spettanze', { params }),

    urlPdf: (id) => `/api/fatturazione/${id}/pdf`,
};

export const pacchettiAPI = {
    perPaziente: (pazienteId) => api.get(`/pacchetti/paziente/${pazienteId}`),
    dettaglio: (id) => api.get(`/pacchetti/${id}`),
    inScadenza: (giorni = 30) => api.get('/pacchetti/in-scadenza', { params: { giorni } }),
    vendi: (dati) => api.post('/pacchetti', dati),
    consuma: (id, dati) => api.post(`/pacchetti/${id}/consuma`, dati),
    fissaScadenza: (id, fatturaId) => api.post(`/pacchetti/${id}/scadenza`, { fattura_id: fatturaId }),
    recesso: (id) => api.get(`/pacchetti/${id}/recesso`),
    chiudi: (id, dati) => api.post(`/pacchetti/${id}/chiudi`, dati),
};

export default fatturazioneAPI;
